$(document).ready(function() {
  const productMap = window.productMap || {}; // Make sure this object is defined in your theme

  // $('.product-card-wrapper .product-card-form').each(function() {
  //   const $form = $(this);

  //   $form.on('submit', function(e) {
  //     const $checkbox = $form.parents('.card-product').find('.subscribe-checkbox');
  //     // If checkbox is NOT checked → allow normal submission
  //     if (!$checkbox.is(':checked')) {
  //       console.log('Normal add to cart');
  //       return; // do not prevent
  //     }

  //     // If checkbox IS checked → redirect to this product's detail page
  //     e.preventDefault();
  //     e.stopImmediatePropagation();
  //     // Try to get the product handle or URL from data attribute on the form/card
  //     // First, check data-product-url or data-handle on card or form
  //     let productUrl = $form.parents('.card-product').data('product-url');
  //     if (!productUrl) {
  //       // fallback: maybe data-handle, must prepend '/products/'
  //       const productHandle = $form.parents('.card-product').data('handle');
  //       if (productHandle) {
  //         productUrl = '/products/' + productHandle;
  //       }
  //     }
  //     if (productUrl) {
  //       window.location.href = productUrl;
  //     } else {
  //       // fallback: try first product link inside card
  //       const $link = $form.parents('.card-product').find('a[href*="/products/"]').first();
  //       if ($link.length) {
  //         window.location.href = $link.attr('href');
  //       } else {
  //         alert('Sorry, could not locate this product page.');
  //       }
  //     }
  //   });
  // });

  // $('.subscribe-checkbox').on('change', function() {
  //     const $label = $(this).closest('label');
  //     const $textSpan = $label.find('.subscribe-text');
  //     const subscribedText = $textSpan.attr('subscribed-text');
  //     const $card_atc_btn = $(this).parents(".card-product").find(".quick-add__submit span");
  //     const atcText = $textSpan.attr('atc-text');

  //     if ($(this).is(':checked')) {
  //       $card_atc_btn.text(subscribedText);
  //     } else {
  //       $card_atc_btn.text(atcText);
  //     }
  // });

  // for collection filter
  const filters = document.querySelectorAll('.template-collection .facets__disclosure-vertical');
  filters.forEach((filter) => {
    filter.addEventListener('toggle', () => {
      if (filter.open) {
        filters.forEach((otherFilter) => {
          if (otherFilter !== filter) {
            otherFilter.removeAttribute('open');
          }
        });
      }
    });
  });

});

// Fix for subscribe-checkbox not working. 
// - Ensure page has loaded before binding
// - Force a short delay to deal with dynamically injected DOM
// - Handle multiple .quick-add__submit span buttons (e.g. desktop/mobile, hidden)
// - Use event delegation for future-proofing

(function() {
  // Helper function to update the ATC button(s) text and behavior
  function updateAtcButton(checkbox) {
    const label = checkbox.closest('label');
    if (!label) return;
    const textSpan = label.querySelector('.subscribe-text');
    if (!textSpan) return;
    const subscribedText = textSpan.getAttribute('subscribed-text');
    const atcText = textSpan.getAttribute('atc-text');
    const cardProduct = checkbox.closest('.card-product');
    if (!cardProduct) return;
    // Changes ALL .quick-add__submit span children (may be >1 for mobile/desktop)
    cardProduct.querySelectorAll('.quick-add__submit span').forEach(function(cardAtcBtnSpan) {
      if (checkbox.checked) {
        cardAtcBtnSpan.textContent = subscribedText;
      } else {
        cardAtcBtnSpan.textContent = atcText;
      }
    });
    // Only set onclick on the button itself if checked
    const cardAtcBtn = cardProduct.querySelector('.quick-add__submit');
    if (cardAtcBtn) {
      if (checkbox.checked) {
        const redirectUrl = cardAtcBtn.getAttribute('data-product-url');
        if (redirectUrl) {
          cardAtcBtn.onclick = function(e) {
            e.preventDefault();
            window.location.href = redirectUrl;
          };
        }
      } else {
        // Remove onclick to restore add-to-cart
        cardAtcBtn.onclick = null;
      }
    }
  }

  // Core initializer to (re)bind and update all relevant checkboxes/buttons.
  function bindAndUpdateSubscribeCheckboxes() {
    document.querySelectorAll('.subscribe-checkbox').forEach(function(checkbox) {
      // Remove any previously assigned event listener to prevent double-binding
      checkbox.removeEventListener('__bzb_subscribe_change', checkbox.__bzb_subscribe_handler || (()=>{}));
      // Create and store a change handler per checkbox
      const handler = function() {
        updateAtcButton(checkbox);
      };
      checkbox.__bzb_subscribe_handler = handler;
      // Attach change listener via custom event type to ensure safe removal
      checkbox.addEventListener('change', handler, { passive: true });
    });
    // On every call, also update states
    document.querySelectorAll('.subscribe-checkbox').forEach(function(checkbox) {
      updateAtcButton(checkbox);
    });
  }

  // Initial binding after DOM ready (short delay for dynamic content)
  document.addEventListener('DOMContentLoaded', function() {
    setTimeout(bindAndUpdateSubscribeCheckboxes, 400);
  });

  // Listen for a generic ajax "complete" event (common on Shopify, e.g. 'ajaxComplete', 'shopify:section:load')
  // Fallback: You might want to trigger 'bzb:afterajax' manually after AJAX dom updates elsewhere in your code.
  [
    'ajaxComplete',
    'shopify:section:load',
    'bzb:afterajax',
    'collection:filter:complete', // custom, if used
  ].forEach(function(evtName) {
    document.addEventListener(evtName, function() {
      // Slight delay ensures any DOM updates/inserts have rendered
      setTimeout(bindAndUpdateSubscribeCheckboxes, 100);
    }, true);
  });

  // Also provide a MutationObserver for robustness in case of framework AJAX (optional, can remove if not needed)
  // Watches for insertion of .subscribe-checkbox input
  if ('MutationObserver' in window) {
    const mo = new MutationObserver(function(mutationsList) {
      let subscriptionInputFound = false;
      for (const mutation of mutationsList) {
        if (mutation.addedNodes) {
          mutation.addedNodes.forEach(function(node) {
            if (node.nodeType === 1 && (
                node.matches('.subscribe-checkbox') ||
                node.querySelector && node.querySelector('.subscribe-checkbox')
              )) {
              subscriptionInputFound = true;
            }
          });
        }
      }
      if (subscriptionInputFound) {
        // Delay to ensure all nodes settled
        setTimeout(bindAndUpdateSubscribeCheckboxes, 20);
      }
    });
    if (document.body && document.body.nodeType === 1) {
      mo.observe(document.body, {
        childList: true,
        subtree: true
      });
    } else {
      // Fallback: re-try when DOMContentLoaded if body was not available
      document.addEventListener('DOMContentLoaded', function() {
        if (document.body && document.body.nodeType === 1) {
          mo.observe(document.body, {
            childList: true,
            subtree: true
          });
        }
      });
    }
  }
})();
// Fast BYOB removals: Remove any .byob-cart-item DOM nodes immediately, and (if present in cart view) remove via change input or "remove" button, then schedule a background real update.
(function() {
  function removeBYOBFromCartIfNeeded() {
    try {
      var script = document.getElementById('cartLiquidJson');
      if (!script) return;

      var cartJsonText = script.textContent || script.innerText || '';
      if (!cartJsonText || cartJsonText === 'null') return; // No cart

      var cart = JSON.parse(cartJsonText);
      if (!cart || !Array.isArray(cart.items) || cart.items.length === 0) return;

      // Find BYOB items
      var hasBYOB = false, updates = {};
      cart.items.forEach(function(item) {
        if (item && typeof item.product_type === 'string' && item.product_type.trim().toUpperCase() === 'BYOB') {
          updates[item.key] = 0;
          hasBYOB = true;
        }
      });

      if (!hasBYOB) return; // Nothing to remove!

      // Remove BYOB items from cart via Shopify ajax
      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify({ updates: updates })
      }).then(function() {
        window.location.reload(); // Reload after removal
      });

    } catch (e) {
      // Silently fail (optional: add console.warn)
    }
  }

  var events = ['DOMContentLoaded', 'ajaxComplete', 'pageshow'];
  events.forEach(function(evt) {
    window.addEventListener(evt, function(e) {
      // For bfcache events, pageshow.persisted === true, but we want to check regardless
      removeBYOBFromCartIfNeeded();
    });
  });

  // Also call immediately in case everything is ready already
  removeBYOBFromCartIfNeeded();
})();


(function () {
  // Local state for cart info to avoid repeated fetches
  let cartState = {
    cart: null,
    subscriptionItems: [],
    nonSubscriptionItems: [],
    hasSubscription: false,
    hasNonSubscription: false,
    subscriptionCount: 0,
    ready: false
  };

  // Update our local cart state from the provided cart object
  function setCartState(cart) {
    if (!cart || !Array.isArray(cart.items)) return;

    const subscriptionItems = cart.items.filter(i =>
      i.properties &&
      (i.properties["_shipping_interval_frequency"] ||
       i.properties["_shipping_interval_unit_type"])
    );

    const nonSubscriptionItems = cart.items.filter(i =>
      !(
        i.properties &&
        (i.properties["_shipping_interval_frequency"] ||
         i.properties["_shipping_interval_unit_type"])
      )
    );

    cartState = {
      cart,
      subscriptionItems,
      nonSubscriptionItems,
      hasSubscription: subscriptionItems.length > 0,
      hasNonSubscription: nonSubscriptionItems.length > 0,
      subscriptionCount: subscriptionItems.length,
      ready: true
    };
  }

  // Helper: fetch cart and update our state (used on initial page loads)
  async function fetchAndStoreCart() {
    try {
      const res = await fetch("/cart.js");
      const cart = await res.json();
      setCartState(cart);
    } catch (e) {
      cartState.ready = false;
    }
  }

  // Update cartState using a provided cart (from AJAX or custom event/broadcast)
  function handleCartUpdateEvent(cart) {
    if (cart) {
      setCartState(cart);
    } else {
      fetchAndStoreCart();
    }
  }
  // PATCH FETCH to enforce rules, using only local cartState (no extra fetch)
  const originalFetch = window.fetch;
  window.fetch = async function (input, options) {
    const url = typeof input === "string" ? input : input.url;
    const isAddToCart = url.includes("/cart/add");

    // Only act if our state is ready and it's an add to cart event
    if (isAddToCart && options?.body && cartState.ready) {
      // Handle both FormData and URLSearchParams/string body
      let freq, unit, incomingId;
      
      if (options.body instanceof FormData) {
        // Handle FormData
        freq = options.body.get("properties[_shipping_interval_frequency]");
        unit = options.body.get("properties[_shipping_interval_unit_type]");
        const idValue = options.body.get("id");
        incomingId = idValue ? parseInt(idValue) : null;
      } else {
        // Handle URLSearchParams or string body
        const formData = new URLSearchParams(options.body);
        freq = formData.get("properties[_shipping_interval_frequency]");
        unit = formData.get("properties[_shipping_interval_unit_type]");
        incomingId = formData.get("id") ? parseInt(formData.get("id")) : null;
      }

      // =====================================================
      // RULE 0: CYQ HARD LOCK (Direct cart check)
      // =====================================================
      if (cartState.cart && Array.isArray(cartState.cart.items)) {

        const hasCyqInCart = cartState.cart.items.some(item =>
          item.properties &&
          Object.prototype.hasOwnProperty.call(item.properties, '_is_cyq')
        );

        //Check if CYQ product in cart
        if (hasCyqInCart) {
          const subscriptionDiv = document.getElementById('subscription-data');

          const conflictMessage = subscriptionDiv?.dataset.conflictMessage || 'Something Went Wrong';
          const withoutOnetimeMessage = subscriptionDiv?.dataset.withoutOnetimeMessage || 'Something Went Wrong';
          
          const addingNewIsSubscription = freq || unit;

          //When cyq product is in cart and adding subscription product.
          if(addingNewIsSubscription){
            showCartPopup(
              //"Cart currently has a subscription product. We recommend to keep each subscription checkout separate for better tracking. Please complete the checkout of subscription product in the cart, and add this product after that checkout."
              conflictMessage
            );
          }else{
            //When cyq product is in cart and adding onetime product.
            showCartPopup(
              //"Cart currently has a subscription product. We recommend to keep each subscription checkout separate for better tracking. Please complete the checkout of subscription product in the cart, and add this product after that checkout."
              withoutOnetimeMessage
            );
          }

          
          return new Response(null, { status: 400 });
        }

      }

      // Detect subscription product
      const addingIsSubscription = freq || unit;
      
      /* RULE 1: Prevent adding non-subscription if subscription exists — disabled to allow mixed cart
      if (cartState.hasSubscription && !addingIsSubscription) {
        const subscriptionDiv = document.getElementById('subscription-data');
        const withoutOnetimeMessage = subscriptionDiv?.dataset.withoutOnetimeMessage || 'Default without-onetime message';
        showCartPopup(withoutOnetimeMessage);  
        return new Response(null, { status: 400 });
      }
      */

      /* RULE 2: Prevent adding subscription if non-subscription exists — disabled to allow mixed cart
      if (cartState.hasNonSubscription && addingIsSubscription) {
        const subscriptionDiv = document.getElementById('subscription-data');
        const onetimeMessage = subscriptionDiv?.dataset.onetimeMessage || 'Please checkout existing items first.';
        showCartPopup(onetimeMessage);
        return new Response(null, { status: 400 });
      }
      */

      /* RULE 3: Only one subscription product allowed — disabled to allow mixed cart
      if (addingIsSubscription && cartState.subscriptionCount > 0) {
        const existingSubId = cartState.subscriptionItems[0].variant_id;

        if (existingSubId !== incomingId) {
        const subscriptionDiv = document.getElementById('subscription-data');
        const conflictMessage = subscriptionDiv?.dataset.conflictMessage || '';
        showCartPopup(conflictMessage);  
          return new Response(null, { status: 400 });
        }
      }
      */
    }

    // Intercept and parse cart on cart actions to update local state
    // We check for /cart/add.js, /cart/change.js, /cart/update.js, /cart/clear.js
    const updateUrls = [
      "/cart/add",
      "/cart/change",
      "/cart/update",
      "/cart/clear"
    ];
    const matched = updateUrls.some(u => url.includes(u));
    const response = await originalFetch.apply(this, arguments);

    if (matched) {
      // Most Shopify endpoints return new cart as JSON
      if (response.ok && response.headers.get('content-type')?.indexOf('application/json') >= 0) {
        try {
          const cloned = response.clone();
          const cart = await cloned.json();
          handleCartUpdateEvent(cart);
        } catch (e) {
          fetchAndStoreCart();
        }
      } else {
        fetchAndStoreCart();
      }
    }

    return response;
  };

  // Use PerformanceObserver to watch for XHR/fetch cart activity, update cart state
  const cartPerfObserver = new PerformanceObserver((entries) => {
    entries.getEntries().forEach((entry) => {
      const isNetworkRequest = ['xmlhttprequest', 'fetch'].includes(entry.initiatorType);
      const isCartRequest = /\/cart\/(add|change|update|clear)/.test(entry.name);
      if (isNetworkRequest && isCartRequest && entry.duration > 0) {
        // We don't have cart response here, so re-fetch just once (if not already updated above)
        fetchAndStoreCart();
      }
    });
  });
  cartPerfObserver.observe({ entryTypes: ['resource'] });

  // Optional: MutationObserver on cart UI, if you want to react to DOM/UI changes
  // Place your widget update logic here if needed
  // const cartNode = document.getElementById('CartContainer') || document.querySelector('[data-cart]');
  // if (cartNode) {
  //   const cartDomObserver = new MutationObserver((mutations, observer) => {
  //     // You may want to check if relevant nodes actually changed
  //   });
  //   cartDomObserver.observe(cartNode, { childList: true, subtree: true });
  // }

  // Listen for custom cart update events (in case you use "cart:updated" events elsewhere)
  document.addEventListener("cart:updated", function (e) {
    // If detail with cart passed, use it, otherwise, just refetch
    if (e.detail && e.detail.cart) {
      handleCartUpdateEvent(e.detail.cart);
    } else {
      fetchAndStoreCart();
    }
  });

  // INIT: Get cart info once on first load for initial state
  if (document.readyState === "complete" || document.readyState === "interactive") {
    fetchAndStoreCart();
  } else {
    document.addEventListener("DOMContentLoaded", fetchAndStoreCart);
  }

  // General validation function for add-to-cart (can be used by quiz section, BYOB, etc.)
  function validateAddToCart(isSubscription, variantId = null) {
    // Wait for cart state to be ready
    if (!cartState.ready) {
      // If not ready, try to fetch cart first (async, but we'll proceed with validation)
      fetchAndStoreCart();
      // For now, allow checkout if state isn't ready (fallback behavior)
      return { valid: true };
    }

    /* RULE 1: Prevent adding non-subscription if subscription exists — disabled to allow mixed cart
    if (!isSubscription && cartState.hasSubscription) {
      const subscriptionDiv = document.getElementById('subscription-data');
      const withoutOnetimeMessage = subscriptionDiv?.dataset.withoutOnetimeMessage || 'Default without-onetime message';
      showCartPopup(withoutOnetimeMessage);
      return {
        valid: false,
      };
    }
    */

    /* RULE 2: Prevent adding subscription if non-subscription exists — disabled to allow mixed cart
    if (isSubscription && cartState.hasNonSubscription) {
      const subscriptionDiv = document.getElementById('subscription-data');
      const onetimeMessage = subscriptionDiv?.dataset.onetimeMessage || 'Please checkout existing items first.';
      showCartPopup(onetimeMessage);
      return {
        valid: false,
      };
    }
    */

    /* RULE 3: Only one subscription product allowed — disabled to allow mixed cart
    if (isSubscription && cartState.subscriptionCount > 0) {
      if (variantId !== null) {
        const existingSubId = cartState.subscriptionItems[0].variant_id;
        if (existingSubId !== variantId) {
          return {
            valid: false,
            message: "Cart currently has one subscription product.  We recommend to keep each subscription checkout separate for better tracking. Please complete the check of subscription product in the cart, and add this product after that checkout."
          };
        }
      } else {
        const subscriptionDiv = document.getElementById('subscription-data');
        const conflictMessage = subscriptionDiv?.dataset.conflictMessage || '';
        showCartPopup(conflictMessage);  
        return {
          valid: false
        };
      }
    }
    */

    return { valid: true };
  }

  // Expose validation function globally for use in other scripts
  window.validateAddToCart = validateAddToCart;

  // BYOB Checkout Button Validation
  function validateBYOBCheckout(selectedType) {
    // Wait for cart state to be ready
    if (!cartState.ready) {
      // If not ready, try to fetch cart first (async, but we'll proceed with validation)
      fetchAndStoreCart();
      // For now, allow checkout if state isn't ready (fallback behavior)
      return { valid: true };
    }

    const isSubscription = selectedType === "subscribe";
    // Use the general validation function
    return validateAddToCart(isSubscription);
  }

  // Handle BYOB checkout button clicks
  function handleBYOBCheckoutClick(e) {
    // Find the selected radio button - look for radio buttons near the clicked button
    // Radio buttons have class .byob-options and are typically in the same container
    const button = e.target.closest('.byob-checkout-btn') || e.target;
    // Find container - try to find parent section or byob container, fallback to document
    let container = button.closest('section') || button.closest('[id*="byob"]') || button.closest('.byob-container');
    if (!container) container = document;
    const selectedRadio = container.querySelector('.byob-options:checked') || document.querySelector('.byob-options:checked');
    
    if (!selectedRadio) {
      // No selection made, prevent checkout
      e.preventDefault();
      e.stopImmediatePropagation();
      alert("Please select a purchase type (One-time or Subscribe) before checkout.");
      return false;
    }

    const selectedType = selectedRadio.value;
    
    // Validate against cart state
    const validation = validateBYOBCheckout(selectedType);
    
    if (!validation.valid) {
      e.preventDefault();
      e.stopImmediatePropagation();
      //alert(validation.message);
      return false;
    }

    // Validation passed, allow the checkout to proceed
    return true;
  }

  //Rule validation popup
  function showCartPopup(message) {
    let popup = document.querySelector('.cart-rule-popup');
    //const logoUrl = window.themeSettings?.subscription_popup_logo || '';
    //const subscriptiontitle = window.themeSettings?.subscriptiontitle || '';
    const subscriptionDiv = document.getElementById('subscription-data');
    const logoUrl = subscriptionDiv?.dataset.logo || '';
    const popupTitle = subscriptionDiv?.dataset.title || '';
      // Create popup if not exists
      if (!popup) {
        popup = document.createElement('div');
        popup.className = 'cart-rule-popup cyq-rule';
        popup.innerHTML = `
          <div class="cart-rule-popup-overlay"></div>
          <div class="cart-rule-popup-content">
            <div class="cart-dls-content">
              <h3>${popupTitle}</h3>
              <button class="cart-rule-popup-close">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M6 18L18 6M6 6L18 18" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </button>
            </div>  
            <div class="cart-btm-content">
               ${logoUrl ? `<img src="${logoUrl}" alt="Popup Logo" />` : ''}  
              <p class="cart-rule-popup-message"></p>
            </div>
            <div class="byob-plan-popup__actions">
              <button type="button" class="btn btn-primary cart-rule-popup-close-button">Close</button>
            </div>
          </div>
        `;
        document.body.appendChild(popup);

        // Close events
        popup.querySelector('.cart-rule-popup-close').addEventListener('click', () => popup.classList.remove('active'));

        popup.querySelector('.cart-rule-popup-close-button').addEventListener('click', () => popup.classList.remove('active'));

        popup.querySelector('.cart-rule-popup-overlay').addEventListener('click', () => popup.classList.remove('active'));

      }

      // Set message
      popup.querySelector('.cart-rule-popup-message').textContent = message;

      // Open popup
      popup.classList.add('active');

  }


  // Attach event listener to BYOB checkout buttons
  function attachBYOBListeners() {
    const byobButtons = document.querySelectorAll('.byob-checkout-btn');
    byobButtons.forEach(button => {
      // Remove existing listener if any (to prevent duplicates)
      if (button.hasAttribute('data-byob-validation-attached')) {
        return;
      }
      button.setAttribute('data-byob-validation-attached', 'true');
      // Use capture phase to ensure this runs before other handlers
      button.addEventListener('click', handleBYOBCheckoutClick, { capture: true });
    });
  }

  // Initialize on DOM ready
  if (document.readyState === "complete" || document.readyState === "interactive") {
    attachBYOBListeners();
  } else {
    document.addEventListener("DOMContentLoaded", attachBYOBListeners);
  }

  // Re-attach listeners after AJAX updates (common in Shopify themes)
  ['ajaxComplete', 'shopify:section:load', 'bzb:afterajax'].forEach(eventName => {
    document.addEventListener(eventName, function() {
      setTimeout(attachBYOBListeners, 100);
    }, true);
  });

  // Also use MutationObserver for dynamic content
  if ('MutationObserver' in window) {
    const byobObserver = new MutationObserver(function(mutationsList) {
      let byobButtonFound = false;
      for (const mutation of mutationsList) {
        if (mutation.addedNodes) {
          mutation.addedNodes.forEach(function(node) {
            if (node.nodeType === 1 && (
                node.matches && node.matches('.byob-checkout-btn') ||
                (node.querySelector && node.querySelector('.byob-checkout-btn')
              ))) {
              byobButtonFound = true;
            }
          });
        }
      }
      if (byobButtonFound) {
        setTimeout(attachBYOBListeners, 20);
      }
    });
    
    if (document.body && document.body.nodeType === 1) {
      byobObserver.observe(document.body, {
        childList: true,
        subtree: true
      });
    } else {
      document.addEventListener("DOMContentLoaded", function() {
        if (document.body && document.body.nodeType === 1) {
          byobObserver.observe(document.body, {
            childList: true,
            subtree: true
          });
        }
      });
    }
  }
})();